module.exports = __webpack_public_path__ + "13e8abbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard_image_in.jpg
// module id = 839
// module chunks = 0 1 2 3 4 5